import styled from 'styled-components';

import { purpurMedia } from '@telialt/common-theme/src/purpurSelectors';
import { FacetsDrawer } from '@telialt/core-search/src/Common/FacetsDrawer/FacetsDrawer';
import { DrawerWrapper } from '@telialt/core-search/src/Common/FacetsDrawer/FacetsDrawer.styles';

const drawerWrapperSelector: string = DrawerWrapper;

export const PlansCustomDrawer = styled(FacetsDrawer).attrs({ visibilityVariant: 'always' })`
    ${purpurMedia('md')`
        flex-basis: 50%;
        ${drawerWrapperSelector} {
            width: 27rem;
        }
    `}
    ${purpurMedia('lg')`
        flex-grow: 0;
        flex-basis: auto;
        margin-left: auto;
    `}
`;
